import manifest from './images.generated.json'

export type ImageVariant = {
  src: string
  width: number
}

export type ResponsiveImageData = {
  width: number
  height: number
  fallback: string
  sources: {
    avif: ImageVariant[]
    webp: ImageVariant[]
    jpeg: ImageVariant[]
  }
}

export type ImageKey = keyof typeof manifest

export const images = manifest as Record<ImageKey, ResponsiveImageData>

export type GalleryImage = {
  image: ResponsiveImageData
  alt: string
  objectPosition: string
  layout: 'wide' | 'portrait' | 'standard'
}

export const galleryImages: GalleryImage[] = [
  { image: images['gallery-01'], alt: 'Diamond Salon reception desk and emerald guest chairs', objectPosition: '45% center', layout: 'wide' },
  { image: images['gallery-03'], alt: 'Private spa treatment room with a massage table and seating', objectPosition: '46% 58%', layout: 'portrait' },
  { image: images['gallery-08'], alt: 'Sunlit salon corner with emerald guest chairs and hanging plants', objectPosition: 'center 58%', layout: 'portrait' },
  { image: images['gallery-02'], alt: 'Bright Diamond Salon styling stations', objectPosition: '48% center', layout: 'standard' },
  { image: images['gallery-04'], alt: 'Salon shampoo stations and gray cabinetry', objectPosition: 'center 62%', layout: 'standard' },
  { image: images['gallery-05'], alt: 'Salon retail shelves with professional hair products', objectPosition: '44% center', layout: 'standard' },
  { image: images['gallery-07'], alt: 'Floral salon wall with a round mirror and wash basin', objectPosition: '46% center', layout: 'portrait' },
  { image: images['gallery-09'], alt: 'Salon coffee bar with a freshly prepared drink', objectPosition: 'center 54%', layout: 'standard' },
  { image: images['gallery-06'], alt: 'Arched hallway leading to Diamond Salon treatment rooms', objectPosition: '58% center', layout: 'portrait' },
]
